module.exports = __webpack_public_path__ + "new-tag-38c50f8a79c3fdb85b2b.png";